const apiUrl = process.env.REACT_APP_API_URL;

export const GetProjecteRecuperacions = async (id_projecte: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${id_projecte}/recuperacions`, {
            cache: 'no-store'
        });
        if (!response.ok) return [];
        return await response.json();
    } catch (error) {
        console.log(error);
        return [];
    }
}

export const PostProjecteRecuperacio = async (id_projecte: string, data: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${id_projecte}/recuperacions`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        if (!response.ok) {
            alert(await response.text());
            return false;
        }
        return true;
    } catch (error) {
        console.log(error);
        return false;
    }
}

export const DeleteProjecteRecuperacio = async (id: number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/recuperacions/${id}`, {
            method: 'DELETE'
        });
        if (!response.ok) {
            alert(await response.text());
            return false;
        }
        return true;
    } catch (error) {
        console.log(error);
        return false;
    }
}

export const PutProjecteRecuperacio = async (id: number, data: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/recuperacions/${id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        if (!response.ok) {
            alert(await response.text());
            return false;
        }
        return true;
    } catch (error) {
        console.log(error);
        return false;
    }
}
